<ng-container *transloco="let t">
    @let playing = playing$ | async;
    @let speedMultiplier = speedMultiplier$ | async;
    @let timeToEmitTemp = timeToEmit.$ | async;
    @let timeToEmitValue = timeToEmit$ | async;
    @let moveTrackerToEnd = moveTrackerToEnd$ | async;
    @let emitting = emitting$ | async;
    @let updateCurrentTime = updateCurrentTime$ | async;
    @let isPlaying = isPlaying$ | async;
    @let deviceOrientation = deviceOrientation$ | async;

    <!-- text inside btn should be used in tooltip -->
    <div #btnPlay>
        <bazis-button
            fill="clear"
            color="action"
            size="compact"
            [ngClass]="{
                'bazis-timeline__play':
                    !isMobile ||
                    (isMobile && deviceOrientation !== BazisDeviceOrientation.Portrait),
            }"
            (click)="setPlaying(!isPlaying)"
        >
            <bazis-icon
                slot="icon-only"
                [name]="isPlaying ? 'pause-solid' : 'play-solid'"
            ></bazis-icon>
        </bazis-button>
        <bazis-tooltip
            class="bh-popper-z-index"
            [reference]="btnPlay"
            [isStatic]="true"
            placement="top-start"
        >
            {{
                t(
                    isPlaying
                        ? 'setupTelemetry.app.map.pauseTooltip'
                        : 'setupTelemetry.app.map.watchTooltip'
                )
            }}
        </bazis-tooltip>
    </div>

    @if (!isMobile || (isMobile && deviceOrientation !== BazisDeviceOrientation.Portrait)) {
        @if (showSpeedMultipliers()) {
            @for (speedMultiplier of speedMultipliers; track $index) {
                <div #btnSpeed>
                    <bazis-button
                        fill="outline"
                        color="action"
                        [active]="speedMultiplier === speedMultiplier"
                        size="compact"
                        class="bazis-timeline__speed"
                        (click)="speedMultiplier$.next(speedMultiplier)"
                    >
                        {{ t('title.timelineSpeed', { number: speedMultiplier }) }}
                    </bazis-button>
                    <bazis-tooltip
                        class="bh-popper-z-index"
                        [reference]="btnSpeed"
                        [isStatic]="true"
                        placement="top"
                    >
                        {{ t('setupTelemetry.app.map.speedTooltip', { number: speedMultiplier }) }}
                    </bazis-tooltip>
                </div>
            }
        }

        @for (action of timelineActions(); track $index; let last = $last) {
            <div #btnAction>
                <bazis-button
                    fill="clear"
                    color="action"
                    size="compact"
                    (click)="toggleActionState(action.code)"
                    [ngClass]="{ 'bh-margin-end-2x': !last }"
                >
                    <bazis-icon
                        [color]="action.active ? 'action' : 'info'"
                        [src]="action?.iconSrc"
                        slot="icon-only"
                        [name]="action.icon"
                    ></bazis-icon>
                </bazis-button>
                <bazis-tooltip
                    class="bh-popper-z-index"
                    [reference]="btnAction"
                    [isStatic]="true"
                    placement="top"
                >
                    {{ t(action.tooltipKey) }}
                </bazis-tooltip>
            </div>
        }
    }

    <div class="bazis-timeline__slider-wrapper">
        <div
            [hidden]="!showChart"
            style="width: 100%"
        >
            <ng-content></ng-content>
        </div>

        <!-- https://angular-slider.github.io/ngx-slider/home -->
        @if (timeToEmitValue) {
            <ngx-slider
                [ngClass]="{
                    'bazis-timeline__slider_mobile':
                        isMobile && deviceOrientation === BazisDeviceOrientation.Portrait,
                }"
                [value]="timeToEmitValue"
                (valueChange)="setValueFromSlider($event, isPlaying, speedMultiplier)"
                [options]="sliderOptions"
            ></ngx-slider>
        }
    </div>

    <!-- text inside btn should be used in tooltip -->
    <div #btnChart>
        <bazis-button
            fill="clear"
            color="action"
            size="compact"
            (click)="showChart = !showChart"
        >
            <bazis-icon
                slot="icon-only"
                name="line-width"
            ></bazis-icon>
        </bazis-button>
        <bazis-tooltip
            class="bh-popper-z-index"
            [reference]="btnChart"
            [isStatic]="true"
            placement="top-end"
        >
            {{
                t(
                    showChart
                        ? 'setupTelemetry.app.map.hideChart'
                        : 'setupTelemetry.app.map.showChart'
                )
            }}
        </bazis-tooltip>
    </div>
</ng-container>
